import { render, staticRenderFns } from "./ChallengerDetailJudges.vue?vue&type=template&id=60c3824e&scoped=true"
import script from "./ChallengerDetailJudges.vue?vue&type=script&lang=ts"
export * from "./ChallengerDetailJudges.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c3824e",
  null
  
)

export default component.exports